module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-selfuser"
  }, [_c('div', {
    staticClass: "kiwi-selfuser-mask"
  }, [_c('span', {
    staticClass: "kiwi-selfuser-nick"
  }, [_vm._v(_vm._s(_vm.network.nick))]), _vm._v(" "), _c('span', {
    staticClass: "kiwi-selfuser-host"
  }, [_vm._v(_vm._s(_vm.netUser.username) + "@" + _vm._s(_vm.netUser.host))])]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-selfuser-modes"
  }, [_vm._v(_vm._s(_vm.modeString))]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-selfuser-actions"
  }, [_c('input-prompt', {
    attrs: {
      "label": _vm.$t('change_nick') + ':'
    },
    on: {
      "submit": _vm.changeNick
    }
  }, [_c('a', {
    staticClass: "u-link"
  }, [_vm._v(_vm._s(_vm.$t('change_nick')))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c363dfc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelfUser.vue
// module id = 490
// module chunks = 2